import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable , Subject} from 'rxjs';
@Component({
  selector: 'app-table-selector',
  templateUrl: './table-selector.component.html',
  styleUrls: ['./table-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableSelectorComponent),
      multi: true
    }
  ]
})
export class TableSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() url: string;
  @Input() dataList: any[];
  @Input() dataObservable: Subject<any[]>;

  @Input() key: string;
  @Input() label: string;
  @Input() columns: any[];


  @Input() maxTagCount: Number = 5;

  @Input() allowClear: boolean = true;
  @Input() placeholder: string = 'Common.PleaseSelect';
  @Input() showSearch: boolean = true;
  @Input() disabled: boolean;

  @Input() value: string | string[];
  @Output() onCodeChange = new EventEmitter<string | string[]>();

  tableData: any[];

  constructor(private httpClient: HttpClient) {
  }

  writeValue(value: string | string[]): void {
    if( value instanceof Array) {
      this.value = value.filter(x => this.tableData?.findIndex(y => y[this.key] == x) != -1)
    } else {
      this.value = value;
    }
    this.propagateOnChange(this.value);
  }

  registerOnChange(fn: any): void {
    this.propagateOnChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  propagateOnChange(value: any) {
  };

  setDisabledState?(disabled: boolean): void {
    this.disabled = disabled;
  }

  ngOnInit() {
    this.dataObservable.subscribe(res => {
      this.tableData = res;
    })
    if (this.dataList && this.dataList.length > 0) {
      this.tableData = JSON.parse(JSON.stringify(this.dataList));
    } else if (this.url) {
      this.httpClient.get<any>(`${this.url}`).subscribe(res => {
        this.tableData = res;
      });
    }
  }

  tableChange($event: string | string[]) {
    this.onCodeChange.emit($event);
    this.propagateOnChange($event);
  }
}
